import React, { useState, useRef } from "react";

import HowWeProtect from "./HowWeProtect";
import HowWeCompare from "./HowWeCompare";
import HowItWorks from "./HowItWorks";
import AboutUs from "./AboutUs";

import { IOffer } from "./Types";
import ScrollToTopButton from "../ScrollToTopButton";

function NavigationTab(props: { offer: IOffer }) {
    const [navigationType, setNavigationType] = useState("howWeProtect");

    document.querySelectorAll(".nav-button").forEach((item) => {
        item.addEventListener("keypress", function (e: any) {
            if (e.key === "Enter") {
                e.target.click();
            }
        });
    });

    return (
        <>
            <div className="container-fluid three-CTA">
                <div className="row">
                    <a
                        id="howWeProtect"
                        tabIndex={0}
                        className={"col-md-3 " + (navigationType === "howWeProtect" ? "active-nav-button" : null)}
                        title="How we protect you"
                        onClick={() => {
                            setNavigationType("howWeProtect");
                            window.addToDataLayer({ event: "dtcSalesLandingTabHowWeProtect" });
                        }}
                    >
                        <h2>How We Protect You</h2>
                    </a>
                    <a
                        id="howWeCompare"
                        tabIndex={0}
                        className={"col-md-3 " + (navigationType === "howWeCompare" ? "active-nav-button" : null)}
                        title="How we compare"
                        onClick={() => {
                            setNavigationType("howWeCompare");
                            window.addToDataLayer({ event: "dtcSalesLandingTabHowWeCompare" });
                        }}
                    >
                        <h2>How We Compare</h2>
                    </a>
                    <a
                        id="howItWorks"
                        tabIndex={0}
                        className={"col-md-3 " + (navigationType === "howItWorks" ? "active-nav-button" : null)}
                        title="How it works"
                        onClick={() => {
                            setNavigationType("howItWorks");
                            window.addToDataLayer({ event: "dtcSalesLandingTabHowItWorks" });
                        }}
                    >
                        <h2>How it Works</h2>
                    </a>
                    <a
                        id="aboutIdentityForce"
                        tabIndex={0}
                        className={"col-md-3 " + (navigationType === "aboutIdentityForce" ? "active-nav-button" : null)}
                        title="About IdentityForce"
                        onClick={() => {
                            setNavigationType("aboutIdentityForce");
                            window.addToDataLayer({ event: "dtcSalesLandingTabAboutIdentityForce" });
                        }}
                    >
                        <h2>About IdentityForce</h2>
                    </a>
                </div>
            </div>

            {navigationType === "howWeProtect" ? (
                <HowWeProtect offer={props.offer} />
            ) : navigationType === "howWeCompare" ? (
                <HowWeCompare offer={props.offer} />
            ) : navigationType === "howItWorks" ? (
                <HowItWorks />
            ) : (
                <AboutUs />
            )}

            <ScrollToTopButton />
        </>
    );
}

export default NavigationTab;
